import { render, staticRenderFns } from "./HrEmployeeLoanCompanyList.vue?vue&type=template&id=23e56eab&lang=pug&"
import script from "./HrEmployeeLoanCompanyList.vue?vue&type=script&lang=js&"
export * from "./HrEmployeeLoanCompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrEmployeeLoanCompanyList.vue"
export default component.exports